export const BANNERS = "banners";
export const RESOURCES = "resources";
export const LOADING = "loading";
